import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import common_da from "./i18next/da/common.json";
import common_en from "./i18next/en/common.json";

const getBrowserLanguage = () => {
  if (typeof window === "undefined") {
    return "en";
  }

  const browserLanguage =
    (window.navigator.languages && window.navigator.languages[0]) ||
    window.navigator.language ||
    "en";

  return browserLanguage.toLowerCase().startsWith("da") ? "da" : "en";
};

// the translations
const resources = {
  en: common_en,
  da: common_da
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: getBrowserLanguage(),
    fallbackLng: "en",
    supportedLngs: ["en", "da"],
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export { getBrowserLanguage };
export default i18n;
